export default {
  user: { academyRequested: false },
}
